import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import FamiglieProdotto from '../famigliaProdotto/famiglieProdotto.jsx'
import { i18n, isAuth, domain, domainVal } from 'arm-common';


class home extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[home.jsx] "
    }

    componentDidMount() {
        console.log(this.componentName + "componentDidMount");
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="mt-3">
                {/* <agui.aCardV4>
                    <agui.aCardV4Header >
                        <h3 className="panel-title">  Welcome, {this.props.utente.userId}</h3> */}
                {isAuth('V2.ADMIN.PRODUCT.VIEW.FAMIGLIE') ?
                    <FamiglieProdotto history={this.props.history} /> :
                    <agui.aCardV4>
                        <agui.aCardV4Header >
                            <h3 className="panel-title">  Welcome, {this.props.utente.userId}</h3>
                        </agui.aCardV4Header>
                    </agui.aCardV4>
                }
                {/* </agui.aCardV4Header>
                    <agui.aCardV4Body>




                    </agui.aCardV4Body>
                </agui.aCardV4> */}
            </div>
        );
    }
};



function mapStateToProps(state) {
    return {
        utente: state.account.utente
    };
};


export default connect(mapStateToProps, null)(home);

